import React, { Component } from 'react';
import './Skills.css'

class Skills extends Component {
    
    render() {
        return (
            <div className="skills_page">
                <div className="s_tmp_msg">
                </div>
                <div className="s_msg">COMING SOON!</div>
                <div className="tmp_massage">I will add certifications and courses to verify <br/>my proficiency in various languages!</div>
            </div>
        )
    }
}

export default Skills